import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { BASE_IMAGE_URL } from "../../config/apiConfig";
import { useHome } from "../../hooks/useHome";
import { setNavbar } from "../../store/slices/uiSlice";
import { menuNavigationInterface } from "../../types/setting.type";

const BottomNavigation: React.FC = () => {
  const { dashboardQuery } = useHome();
  const dispatch = useDispatch();
  const navbar :any= [
    {
        "type": "navbar",
        "name": "home",
        "label": "Trang chủ",
        "active": true,
        "icon": "/assets/icons/nav/home.svg"
    },
    {
        "type": "navbar",
        "name": "movie",
        "label": "Phim",
        "icon": "/assets/icons/nav/movie.svg"
    },
    {
        "type": "button",
        "name": "game",
        "color": "red",
        "label": "Chơi Game",
        "icon": "/assets/icons/nav/game.svg"
    },
    {
        "type": "navbar",
        "name": "comic",
        "label": "Truyện tranh",
        "icon": "/assets/icons/nav/comic.svg"
    },
    {
        "type": "navbar",
        "name": "chat",
        "label": "Trò chuyện",
        "icon": "/assets/icons/nav/love.svg"
    }
]
  // Lưu dữ liệu vào store khi có dữ liệu từ API
  useEffect(() => {
    if (dashboardQuery.data?.data?.navbar) {
      dispatch(setNavbar(dashboardQuery.data.data.navbar));
    }
  }, [dashboardQuery.data, dispatch]);

  const location = useLocation();
  const lang = location.pathname.split("/")[1] || "vi"; // Extract language from the path or default to "vi"

  // Map API `name` to corresponding `pathname`
  const getPathnameFromName = (name: string): string => {
    switch (name) {
      case "home":
        return `/`; // Changed from `/${lang}` to root path
      case "movie":
        return `/${lang}/movies`;
      case "game":
        return `/${lang}/games`;
      case "comic":
        return `/${lang}/comics`;
      case "chat":
        return "https://chat.phim3s.net";
      default:
        return `/`;
    }
  };

  // Check if current path matches a navigation item's path
  const isPathActive = (itemName: string) => {
    if (itemName === "home") {
      // Home is active for both / and /:lang
      return location.pathname === "/" || location.pathname === `/${lang}`;
    }
    return location.pathname === getPathnameFromName(itemName);
  };

  const currentTab = navbar?.find(
    (item:any) => item.name && 
    (item.name !== "chat" ? 
      isPathActive(item.name) : 
      false)
  );
  
  const isHomePage = currentTab?.name === "home" || location.pathname === "/" || location.pathname === `/${lang}`;
  
  // Calculate the middle index
  const middleIndex = Math.floor((navbar?.length || 0) / 2);

  return (
    <div className="footer fixed z-10 bottom-0 left-0 right-0 pt-2 pb-2 border-t border-gray-900 bg-mainBlack">
      <div className="flex justify-center w-screen">
        <div className={`container navbar flex flex-row w-full `}>
          {navbar?.map((item: menuNavigationInterface, index: number) => (
            <div
              key={item.name}
              className={`nav-item flex w-full text-center flex-col gap-1 transition-transform items-center justify-center  ${
                index === middleIndex
                  ? ""
                  : isHomePage && item.name === "home"
                  ? "text-primary"
                  : "opacity-75"
              }`}
            >
              {index === middleIndex ? (
                <div className="flex w-[20vw] relative items-center justify-center">
                  <div 
                    className="flex w-full items-center justify-center bg-primary rounded-xl gap-2 px-2 h-14 absolute -bottom-0 cursor-pointer"
                    onClick={() => window.open(`https://phim3s.net/vi/game/`, '_blank')}
                  >
                    <div className="flex items-center gap-2 w-full h-full justify-center">
                      <span className="icon h-7">
                        <img
                          src={`${item.icon}`}
                          alt={item.label}
                          className="h-7 w-7"
                        />
                      </span>
                      <span className="text-[12px] font-semibold">{item.label}</span>
                    </div>
                  </div>
                </div>
              ) : (
                item.name === "chat" ? (
                  <a href="https://phim3s.net/vi/chat/" target="_blank" rel="noopener noreferrer" className="flex flex-col items-center">
                    <span className="icon h-7">
                      <img
                        src={`${item.icon}`}
                        alt={item.label}
                        className="h-7 w-7"
                      />
                    </span>
                    <span className="text-[10px] font-semibold text-white">{item.label}</span>
                  </a>
                ) : (
                  <Link to={getPathnameFromName(item.name || "")} className="flex flex-col items-center">
                    <span className="icon h-7">
                      <img
                        src={`${item.icon}`}
                        alt={item.label}
                        className="h-7 w-7"
                        style={{
                          filter: currentTab?.name === item.name
                            ? "brightness(0) saturate(100%) invert(21%) sepia(92%) saturate(7483%) hue-rotate(0deg) brightness(95%) contrast(105%)"
                            : "none",
                        }}
                      />
                    </span>
                    <span className={`text-[10px] font-semibold ${
                  currentTab?.name === item.name ? "text-primary" : "text-white"
                }`}>{item.label}</span>
                  </Link>
                )
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BottomNavigation;
